import { useState, useEffect } from "react";
import http from "../../../helpers/http";
import { doObjToFormData } from "../../../helpers/helpers";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../../utils/siteSettings";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import paths from "../../../constants/paths";
import { getAuthUserToken } from "../../../helpers/authToken";

export default function DeleteAccount({
  reasons,
  onCancel,
  showPopup,
  mem_subscribed,
}) {
  const [reason, setReason] = useState("");
  const [otherReason, setOtherReason] = useState("");
  const [password, setPassword] = useState("");
  const [confirmChecked, setConfirmChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [disablePermanently, setDisablePermanently] = useState(false);
  // console.log("reasons", reasons);

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    if (e.target.value !== "other") {
      setOtherReason("");
    }
  };

  useEffect(() => {
    if (!showPopup) {
      setReason("");
      setOtherReason("");
      setPassword("");
      setConfirmChecked(false);
      setDisablePermanently(false);
    }
  }, [showPopup]);

  const handleSubmitConfirm = async (e) => {
    e.preventDefault();

    const finalReason = reason === "other" ? otherReason : reason;

    if (!finalReason.trim()) {
      toast.error("Please provide a reason.", TOAST_SETTINGS);
      return;
    }
    if (!password.trim()) {
      toast.error("Please enter your password.", TOAST_SETTINGS);
      return;
    }
    if (!confirmChecked) {
      toast.error(
        "Please agree to the Terms and Conditions before deleting your account.",
        TOAST_SETTINGS
      );
      return;
    }

    setLoading(true);

    try {
      const formData = doObjToFormData({
        token:getAuthUserToken(),
        reason: finalReason,
        password: password.trim(),
      });

      const res = await http.post("user/delete_account", formData);

      if (res?.data?.status === 1) {
        toast.success("Account deleted successfully.", TOAST_SETTINGS);
        localStorage.removeItem("authToken");
        Cookies.remove("authToken", { domain: process.env.REACT_APP_DOMAIN, path: "/" });
        setDisablePermanently(true);
        setTimeout(() => {
          window.location.replace(paths.SITE_BASE_URL + "/signin");
          // window.location.href = "/signin";
        }, 2000);
      } else {
        toast.error(
          res?.data?.msg || "Account deletion failed.",
          TOAST_SETTINGS
        );
      }
    } catch (err) {
      toast.error("Server error. Try again.", TOAST_SETTINGS);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className={
        showPopup
          ? "popup popup_delete_account text_popup active"
          : "popup popup_delete_account text_popup"
      }
    >
      <div className="table_dv">
        <div className="table_cell">
          <div className="_inner">
            <div className="x_btn" onClick={onCancel}></div>

            {mem_subscribed !== null && (
              <>
                <div className="warning">
                  <h4>Disclaimer!</h4>
                  <p>
                    <strong>You have an active subscription.</strong>
                    Deleting your account will cancel it.
                  </p>
                  <br />
                </div>
              </>
            )}

            <form onSubmit={handleSubmitConfirm}>
              <div className="form_row row">
                <div className="col-sm-12">
                  <h5>Why are you deleting?</h5>
                </div>
                {[...(reasons?.map((r) => r.title) || []), "other"].map(
                  (option) => (
                    <div className="col-sm-12" key={option}>
                      <div className="lbl_btn">
                        <input
                          type="radio"
                          name="reason"
                          value={option}
                          checked={reason === option}
                          onChange={handleReasonChange}
                        />
                        <label>{option === "other" ? "Other" : option}</label>
                      </div>
                    </div>
                  )
                )}

                {/* {[
                  "No longer needed",
                  "Duplicate account",
                  "Privacy concern",
                  "other",
                ].map((option) => (
                  <div className="col-sm-12" key={option}>
                    <div className="lbl_btn">
                      <input
                        type="radio"
                        name="reason"
                        value={option}
                        checked={reason === option}
                        onChange={handleReasonChange}
                      />
                      <label>{option === "other" ? "Other" : option}</label>
                    </div>
                  </div>
                ))} */}
                {reason === "other" && (
                  <div className="col-sm-12">
                    <textarea
                      placeholder="Please specify..."
                      className="input"
                      value={otherReason}
                      onChange={(e) => setOtherReason(e.target.value)}
                    />
                  </div>
                )}

                <div className="col-sm-12">
                  <h5>Confirm your account password</h5>
                  <input
                    type="password"
                    className="input"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>

                <div className="col-sm-12">
                  <div className="lbl_btn">
                    <input
                      type="checkbox"
                      id="delete_agreement"
                      checked={confirmChecked}
                      onChange={(e) => setConfirmChecked(e.target.checked)}
                    />
                    <label htmlFor="delete_agreement">
                      I agree to the{" "}
                      <Link
                        target="_blank"
                        to={paths.PUBLIC_SITE_URL + "terms-conditions"}
                      >
                        Terms and Conditions
                      </Link>{" "}
                      and understand that this account cannot be recovered.
                    </label>
                  </div>
                </div>
              </div>

              <div className="btn_blk text-center">
                <button
                  type="submit"
                  className="site_btn confirm-btn"
                  disabled={loading || disablePermanently}
                >
                  {loading ? "Deleting..." : "Delete"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
